<template>
  <div class="content">
    <!-- 分类导航 -->
    <div class="typenav">
      <TypeNav :rootMenus="rootMenus" @switchover="cut" />
    </div>
    <div class="box">
      <div class="right">
        <!--路由出口-->
        <transition name="el-fade-in-linear">
          <div class="main-content">
            <router-view></router-view>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import TypeNav from "@/components/TypeNav";
// import Information from "./Information";
// import LeftSidebar from "./LeftSidebar";
import { GetCustomerInfoById } from "@/api/user";

import { GetCustomMenu } from "@/api/home";
export default {
  name: "XHome",
  components: { TypeNav },
  async mounted() {
    const res = await GetCustomMenu("1300000000001");
    console.log(res.result.rootMenus);
    this.rootMenus = res.result.rootMenus;
    this.getUserInfo()
  },
  data() {
    return {
      rootMenus: [],
      studentInfo: '',
      num: 3,
      is: true,
    };
  },

  methods: {
    // 获取个人信息
    async getUserInfo() {
      const res = await GetCustomerInfoById();
      this.studentInfo = res.result.nickName;
      sessionStorage.setItem("setStudentInfo", JSON.stringify(res.result));
    },
    showsss(isCollapse) {
      this.is = !isCollapse;
    },
    cut(index) {
      this.num = index;
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;

  .typenav {
    width: 100%;
  }

  .box {
    width: 100%;
    display: flex;

    .right {
      width: 1280px;
      margin: 0 auto;
      margin-top: 120px;
    }
  }
}
</style>
